import React, { useContext, useEffect, useState } from "react"
import { Col, Row, Button } from "react-bootstrap"
import Select from "react-select"
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/Table"
import {
  numberFormat,
  selectDropdownStyle,
  TokenExpiry,
} from "../../../Helpers/Utils/Common"
import downloadIcon from "../../../Assets/Images/download_icon.png"
import Moment from "moment"
import { CSVLink } from "react-csv"
import DatePicker from "react-datepicker"

import { getAllSuppliers } from "../../../Helpers/apiCalls/suppliersApi"
import { getAllExpenseType } from "../../../Helpers/apiCalls/expensetypesApi"
import { searchPayablesAgingReport } from "../../../Helpers/apiCalls/ExpensesReports/ExpenseReportApi"
import Footer from "../../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import { Context } from "../../../Helpers/Utils/Context"
import moment from "moment"

export default function PayablesAgingReport() {
  const [inactive, setInactive] = useState(true)
  const { setDateFrom, setDateTo, dateFilter } = useContext(Context)
  const [filterConfig, setFilterConfig] = useState({
    payment_status: "paid",
    date_from: dateFilter.date_from || new Date(),
    date_to: dateFilter.date_to || new Date(),
    page: 1,
  })

  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }
  const [showLoader, setShowLoader] = useState(false)
  const [allData, setAllData] = useState([])
  const [totalPayables, setTotalPayables] = useState({})
  const [suppliers, setSuppliers] = useState([])
  const [expenseTypes, setExpenseTypes] = useState([])
  const excelHeaders = [
    { label: "Date Paid", key: "added_on" },
    { label: "Franchisee", key: "franchisee_name" },
    { label: "Branch", key: "branch_name" },
    { label: "Doc Type", key: "doc_type" },
    { label: "Marketing Fee", key: "marketing_fee" },
    { label: "Royalty Fee", key: "royalty_fee" },
    { label: "Sales Invoice", key: "sales_invoice" },
    { label: "Deposit Date", key: "deposit_date" },
    { label: "Deposit To", key: "deposit_to" },
    { label: "Check No", key: "check_no" },
    { label: "Pay Mode", key: "pay_mode" },
    { label: "Check Date", key: "check_date" },
  ]

  async function fetchSuppliers() {
    setShowLoader(true)
    setSuppliers([])

    const response = await getAllSuppliers(filterConfig)
    if (response.error) {
      TokenExpiry(response.error)
    } else {
      var supplier = response.data.data.map((data) => {
        var info = {}
        info.label = data.trade_name
        info.value = data.id
        return info
      })
      setSuppliers([{ label: "All Suppliers", value: "" }, ...supplier])
    }
    setShowLoader(false)
  }

  async function fetchExpenseTypes() {
    setShowLoader(true)
    setExpenseTypes([])

    const response = await getAllExpenseType(filterConfig)
    if (response.error) {
      TokenExpiry(response.error)
    } else {
      var types = response.data.map((data) => {
        var info = {}
        info.label = data.name
        info.value = data.id
        return info
      })
      setExpenseTypes([{ label: "All Expense Types", value: "" }, ...types])
    }
    setShowLoader(false)
  }

  async function fetchData() {
    setShowLoader(true)
    setAllData([])
    setTotalItems(0)

    const response = await searchPayablesAgingReport(filterConfig)

    if (response.data) {
      var allBills = response.data.data.map((bill) => {
        var info = bill
        info.branch_id = bill.branch_id
        info.total = bill.total ? numberFormat(bill.total) : 0
        info.check_date =
          bill.cheque_date !== "0000-00-00"
            ? Moment(bill.cheque_date).format("MM-DD-YYYY")
            : "N/A"
        return info
      })

      var payables = response.data.summary
      setTotalPayables(payables)
      setAllData(allBills)
      setTotalItems(response.data.size)
    }

    setShowLoader(false)
  }

  // function handleViewPO(invoice_id,expense_type_id) {
  //     window.open(
  //       "/se/purchaseinvoices/print/" + invoice_id,
  //       "_blank"
  //     );
  //   }
  function handleViewPO(invoice_id, expense_type_id) {
    let url
    if (expense_type_id == 0) {
      url = "/purchaseinvoices/print/" + invoice_id
    } else {
      url = "/se/purchaseinvoices/print/" + invoice_id
    }
    window.open(url, "_blank")
  }

  function getLabel(row) {
    var idUsed
    if (
      row.invoice_no &&
      row.invoice_no !== "undefined" &&
      row.invoice_no !== "null"
    ) {
      idUsed = row.invoice_no
    } else if (row.dr_no && row.dr_no !== "undefined" && row.dr_no !== "null") {
      idUsed = row.dr_no
    } else if (
      row.waybill_no &&
      row.waybill_no !== "undefined" &&
      row.waybill_no !== "null"
    ) {
      idUsed = row.waybill_no
    }
    // return `Invoice ${idUsed} - ${numberFormat(row.total_balance)}`
    // return `${<Button className="" variant="outline-warning" size="sm"onClick={() => handleViewPO(row.invoice_id)}>{`Inv-${idUsed}`}</Button>} - ${numberFormat(row.total_balance)}`
    // const buttonComponent = (
    //     <Button
    //       className=""
    //       variant="outline-warning"
    //       size="sm"
    //       onClick={() => handleViewPO(row.invoice_id)}
    //     >
    //       {`Inv-${idUsed}`}
    //     </Button>
    //   );

    // Return the button component within the string
    return (
      <>
        <button
          type="button"
          className="button-secondary table-button p-1"
          onClick={() => handleViewPO(row.invoice_id, row.expense_type_id)}
        >
          {`Inv-${idUsed} - ${numberFormat(row.total_balance)}`}
        </button>
        {/* <span
                    className="me-4 align-middle ps-label blue"
                    onClick={() => handleViewPO(row.invoice_id)}
                >
                    {`Inv-${idUsed} - ${numberFormat(row.total_balance)}`}
                </span> */}
      </>
    )
  }

  function splitData(row, header) {
    const split = row[header]

    return (
      <Row>
        {split?.map((data) => {
          return getLabel(data)
        })}
      </Row>
    )
  }

  useEffect(() => {
    fetchData()
  }, [filterConfig, currentPage])

  useEffect(() => {
    fetchSuppliers()
    fetchExpenseTypes()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"EXPENSES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={10}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              Payables Aging Report{" "}
            </h1>
          </Col>
        </Row>

        <div className="tab-content">
          {/* filters */}
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Supplier"
                styles={selectDropdownStyle}
                options={suppliers}
                onChange={(e) => {
                  setFilterConfig((prev) => {
                    return { ...prev, supplier_id: e.value }
                  })
                }}
              />
            </Col>
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Expense Type"
                styles={selectDropdownStyle}
                options={expenseTypes}
                onChange={(e) => {
                  setFilterConfig((prev) => {
                    return { ...prev, expense_id: e.value }
                  })
                }}
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                selected={filterConfig.date_from}
                name="date_from"
                placeholderText={Moment().format("MM/DD/YYYY")}
                onChange={(date) => {
                  setDateFrom(moment(date).format("YYYY-MM-DD"))
                  setFilterConfig((prev) => {
                    return { ...prev, date_from: date }
                  })
                }}
                fixedHeight
                className="date-filter me-4 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                dateFormat={"MMM dd, yyyy"}
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                selected={filterConfig.date_to}
                name="date_to"
                placeholderText={Moment().format("MM/DD/YYYY")}
                onChange={(date) => {
                  setDateTo(moment(date).format("YYYY-MM-DD"))
                  setFilterConfig((prev) => {
                    return { ...prev, date_to: date }
                  })
                }}
                fixedHeight
                className="date-filter ps-label-content me-5 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                dateFormat={"MMM dd, YYYY"}
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
          </Row>
          <div className="mb-2" />

          <div className="my-2 px-2 PO-filters d-flex justify-content-center">
            <span className="me-4 ml-4 align-middle ps-label">
              Total Payables: {numberFormat(totalPayables.total_payables)}
            </span>
          </div>

          <div className="below">
            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                // "-",
                "SUPPLIER",
                "CURRENT",
                "1-30",
                "31-60",
                "61-90",
                "ABOVE 90",
                "TOTAL",
              ]}
              headerSelector={[
                // "-",
                "trade_name",
                "current",
                "one_to_thirthy",
                "thirtyone_to_sixty",
                "sixtyone_to_ninety",
                "above_ninety",
                "total",
              ]}
              tableData={allData}
              currentAging={(row) => splitData(row, "current")}
              oneToThirty={(row) => splitData(row, "one_to_thirty")}
              thirtyOneToSixty={(row) => splitData(row, "thirtyone_to_sixty")}
              sixtyOneToNinety={(row) => splitData(row, "sixty_to_ninety")}
              aboveNinetyAging={(row) => splitData(row, "above_ninety")}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
          </div>
          <div className="mb-2" />
        </div>
        <br />
        <br />
        <Row className="mb-4">
          <Col xs={12} lg={10}></Col>
          <Col lg={2} className="mt-2 mt-lg-0">
            <div className="PO-filters">
              <CSVLink
                data={allData}
                headers={excelHeaders}
                type="button"
                className="primary-btn"
              >
                <span className="me-2">
                  <img
                    alt="download"
                    width={20}
                    height={20}
                    src={downloadIcon}
                  ></img>
                </span>
                Download
              </CSVLink>
            </div>
          </Col>
        </Row>
        <br />
        <br />
      </div>
      <Footer />
    </div>
  )
}
